import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { vendorAuthApi } from '@/lib/vendorApi';

export function VendorTotpPage() {
  const navigate = useNavigate();
  const [token,   setToken]   = useState('');
  const [error,   setError]   = useState('');
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await vendorAuthApi.verifyTotp(token);
      navigate('/vendor');
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Invalid code');
      setToken('');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="min-h-screen bg-slate-900 flex items-center justify-center p-6">
      <div className="bg-slate-800 rounded-xl border border-slate-700 p-8 w-full max-w-sm">
        <h1 className="text-xl font-bold text-white mb-1">Two-Factor Auth</h1>
        <p className="text-slate-400 text-sm mb-6">Enter the 6-digit code from your authenticator app</p>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <input
            type="text"
            inputMode="numeric"
            maxLength={6}
            value={token}
            onChange={e => setToken(e.target.value.replace(/\D/g, ''))}
            placeholder="000000"
            required
            autoFocus
            className="w-full bg-slate-900 border border-slate-600 rounded-lg px-3 py-3 text-white text-2xl font-mono text-center tracking-widest focus:outline-none focus:ring-2 focus:ring-brand-500"
          />
          {error && <p className="text-red-400 text-sm">{error}</p>}
          <button
            type="submit"
            disabled={loading || token.length !== 6}
            className="bg-brand-600 hover:bg-brand-700 disabled:opacity-50 text-white font-semibold py-2 px-4 rounded-lg text-sm transition-colors"
          >
            {loading ? 'Verifying...' : 'Verify'}
          </button>
          <button
            type="button"
            onClick={() => navigate('/vendor/login')}
            className="text-slate-500 hover:text-slate-400 text-xs text-center"
          >
            Back to login
          </button>
        </form>
      </div>
    </div>
  );
}
